import { render, staticRenderFns } from "./tabPillButton.vue?vue&type=template&id=157d9bd9&scoped=true&"
import script from "./tabPillButton.vue?vue&type=script&lang=js&"
export * from "./tabPillButton.vue?vue&type=script&lang=js&"
import style0 from "./tabPillButton.vue?vue&type=style&index=0&id=157d9bd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d9bd9",
  null
  
)

export default component.exports